var _rect, _mask, _path, _path2, _rect2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1216,
    height: 700,
    viewBox: "0 0 1216 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 643,
    width: 1162,
    height: 52,
    rx: 26,
    fill: "#302C2C",
    stroke: "black",
    strokeWidth: 4
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1_217",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116 42C116 18.804 134.804 0 158 0H1058C1081.2 0 1100 18.804 1100 42V641H116V42Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116 42C116 18.804 134.804 0 158 0H1058C1081.2 0 1100 18.804 1100 42V641H116V42Z",
    fill: "#3F3F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111 42C111 16.0426 132.043 -5 158 -5H1058C1083.96 -5 1105 16.0426 1105 42H1095C1095 21.5655 1078.43 5 1058 5H158C137.565 5 121 21.5655 121 42H111ZM1100 641H116H1100ZM111 641V42C111 16.0426 132.043 -5 158 -5V5C137.565 5 121 21.5655 121 42V641H111ZM1058 -5C1083.96 -5 1105 16.0426 1105 42V641H1095V42C1095 21.5655 1078.43 5 1058 5V-5Z",
    fill: "black",
    mask: "url(#path-2-inside-1_1_217)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 53,
    width: 198,
    height: 100,
    rx: 26,
    fill: "#272C38",
    fillOpacity: 0.25
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 90.5,
    r: 12.5,
    fill: "#D49CCE",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M548 421V221L698 321.168L548 421Z",
    fill: "#066AB7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M523 645H694V645C694 661.016 681.016 674 665 674H552C535.984 674 523 661.016 523 645V645Z",
    fill: "#5A5454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.fa2ff2c39079e10e8da200d92f199f85.svg";
export { ForwardRef as ReactComponent };